/**
 * Indicates that the resource has a possible "loading" state
 */
export class Loading {
    protected dummy: Loading;
}

const loadingObj = new Loading();

/**
 * Returns the [Loading] value; set a resource to this value to
 * indicate that it is currently loading
 */
export function loading(): Loading {
    return loadingObj;
}

/**
 * Checks if the resource is currently loading
 */
export function isLoading<T>(x: T | Loading): x is Loading {
    return x === loadingObj;
}



// WEBPACK FOOTER //
// ./src/Loading.ts